import { withHandlers } from 'recompose';
import { omit, without } from 'lodash';

const withTableHandlers = withHandlers({
  onRowSelectionChange: (props) => async (row, event) => {
    const { setLoading, ensureShopBarbersLoaded } = props;
    const { id, shopId } = row;
    const isShop = !shopId;
    const isChecked = event.target.checked;

    setLoading(row, true);

    /**
     * if it is barber row
     * take existent barbers and send assign request with the new list of barbers
     */
    if (!isShop) {
      let shopAssignment = props.getAssignment({ id: shopId });
      /**
       * if shop assignment is empty we should create it first
       */
      if (!shopAssignment) {
        shopAssignment = await props.saveShopAssignment(shopId);
      }

      const barbersIds = Object.keys(shopAssignment.assignments);
      const newBarbers = isChecked ? [...barbersIds, id] : without(barbersIds, id);
      await props.saveBarbersAssignments(shopId, newBarbers);
      setLoading(row, false);
      return;
    }

    /**
     * if it's a shop row
     */
    if (isChecked) {
      await props.saveShopAssignment(id);
      setLoading(row, false);

      // Load barbers if not already loaded
      const shopBarbers = await ensureShopBarbersLoaded(id);
      if (!shopBarbers) {
        return;
      }

      const barbersIds = shopBarbers.map((barber) => barber.id);
      barbersIds.forEach((barberId) => setLoading({ id: barberId, shopId: id }, true));
      await props.saveBarbersAssignments(id, barbersIds);
      barbersIds.forEach((barberId) => setLoading({ id: barberId, shopId: id }, false));
    } else {
      await props.removeShopAssignment(id);
      setLoading(row, false);
    }
  },
  onFieldChange: (props) => async (row, fieldName, value) => {
    const { setLoading } = props;
    const { id, shopId } = row;
    const isShop = !shopId;

    setLoading(row, true);
    const assignment = props.getAssignment(row);

    /**
     * if it is a barber row
     */
    if (!isShop) {
      await props.saveBarberAssignment(shopId, id, {
        ...assignment,
        [fieldName]: value,
      });
      setLoading(row, false);
      return;
    }

    /**
     * if it is a shop row
     */
    await props.saveShopAssignment(id, {
      ...omit(assignment, ['assignments']),
      [fieldName]: value,
    });
    setLoading(row, false);
  },
});

export default withTableHandlers;
